/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Filter cases by verdict
 * @export
 */
export const ControlVerdict8 = {
    Malicious: 'MALICIOUS',
    Suspicious: 'SUSPICIOUS',
    Benign: 'BENIGN'
} as const;
export type ControlVerdict8 = typeof ControlVerdict8[keyof typeof ControlVerdict8];


export function ControlVerdict8FromJSON(json: any): ControlVerdict8 {
    return ControlVerdict8FromJSONTyped(json, false);
}

export function ControlVerdict8FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlVerdict8 {
    return json as ControlVerdict8;
}

export function ControlVerdict8ToJSON(value?: ControlVerdict8 | null): any {
    return value as any;
}

